import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation sendSlaEmail($id: String!) {
    sendSlaEmail(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const sendSlaEmailRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/send_sla_email',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.sendSlaEmail;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const sendSlaEmailSlice = createSlice({
  name: 'send_sla_email',
  initialState: initialState,
  reducers: {
    sendSlaEmailClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(sendSlaEmailRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(sendSlaEmailRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(sendSlaEmailRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { sendSlaEmailClear } = sendSlaEmailSlice.actions;

export const sendSlaEmail = createSelector(
  (state: RootState) => state.organization.sendSlaEmail.result,
  (state: RootState) => state.organization.sendSlaEmail.error,
  (state: RootState) => state.organization.sendSlaEmail.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default sendSlaEmailSlice.reducer;